import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TarefasRelatosService {
  private tarefasRelatosAtualizados = new Subject<void>();

  tarefasRelatosAtualizados$ = this.tarefasRelatosAtualizados.asObservable();

  emitirAtualizacao(): void {
    this.tarefasRelatosAtualizados.next();
  }
}
